export enum RoutePath {
  Root = "/",
  Player = "/player",
  UrlStoreTest = "/urlStoreTest",
  Videos = "/videos",
  ComputerVisionRuns = "/computerVisionRuns",
  ValidationRuns = "/validationRuns",
}
